import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MailBoxService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api"; 
  
  getAllMailBoxData(Page: any, size: any, type: any,pageToken): Observable<Object> {
  const TIMEOUT_DURATION = 30000; // 30 seconds timeout
  
  return this.http.get(`${this.url}/inbox/mail?page=${Page}&size=
    ${size}&type=${type}&pageToken=${pageToken}`).pipe(
    timeout(TIMEOUT_DURATION),
    catchError(error => {
      if (error instanceof TimeoutError) {
        console.error('Request timed out after 30 seconds');
        return throwError(new Error('Request timed out'));
      }
      return throwError(error);
    })
  );
}

  checkMail(type: any): Observable<Object> {
    return this.http.get(`${this.url}/inbox/check/connection?type=${type}`);
  }

  checkSmtpConnection(smtpConfig: any): Observable<Object> {
    return this.http.post(`${this.url}/inbox/check/smtp`, smtpConfig);
  }

  filterByEmail(Page: any, size: any, type: any,searchTerm): Observable<Object> {
    return this.http.get(`${this.url}/inbox/mail/search?page=${Page}&size=${size}&type=${type}&searchTerm=${searchTerm}`);
  }

   deleteByUidId(uid): Observable<Object> {
    return this.http.delete(`${this.url}/inbox/mail/${uid}`);
  }

}
